import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Figure } from 'react-bootstrap';
import '../../../assets/scss/sections/_herosection.scss';
import { getCurrentDimension } from '../../../helpers';

const HeroSection = ({ hero_section_data, hero_section_list_data }) => {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [styleCss, setStyleCss] = useState('../../images/BannerImage1.svg');

  /**
   * This will run on page renders, and read data from localstorage,
   * and set it to their corresponding states
   */
  useEffect(() => {
    const updateDimension = (hero_section_data) => {
      setScreenSize(getCurrentDimension());
      sectionStyle(hero_section_data);
    };
    window.addEventListener('resize', updateDimension);
    sectionStyle(hero_section_data);
    return () => {
      window.removeEventListener('resize', updateDimension);
    };
  }, [screenSize, hero_section_data]);

  /**
   * Custom Style for status options
   */
  const sectionStyle = (hero_section_data) => {
    if (screenSize.width > 991) {
      setStyleCss(hero_section_data.home_page_banner_image_1);
    } else if (screenSize.width >= 575 && screenSize.width <= 991) {
      setStyleCss(hero_section_data.home_page_banner_image_2);
    } else {
      setStyleCss(hero_section_data.home_page_banner_image_3);
    }
  };
  return (
    <>
      <section id="hero_section" style={{ backgroundImage: 'url("' + styleCss + '")' }}>
        <Container>
          <Row>
            <Col lg={5} md={12} sm={12}>
              <div className="herosection_wrapper">
                <h1 className="hero_title">
                  {hero_section_data?.home_page_banner_title_1}
                  <span className="title_highlight">
                    {hero_section_data?.home_page_banner_title_2}
                  </span>
                  <span className="delivery_partner">
                    {hero_section_data?.home_page_banner_title_3}
                  </span>
                </h1>
                <p className="hero_content">{hero_section_data?.home_page_banner_sub_title}</p>
                <a href="#" className=" hero_btn learn_button">
                  {hero_section_data?.home_page_banner_button_text}
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="our_clients" className="wave_blue client_wave">
        <Container>
          <h3 className="main_common_title text-center">
            <span className="common_span"> {hero_section_data?.home_page_our_client_title_1}</span>
            {hero_section_data?.home_page_our_client_title_2}
          </h3>
          <div className="our_client_row">
            <Row>
              <Col sm={12}>
                <div className="our_client_wrapper">
                  {hero_section_list_data.map((team) => (
                    <div className="our_client_figure" key={team.home_page_heathcare_id.toString()}>
                      <a href="#">
                        <div className="our_client_img">
                          <Figure>
                            <Figure.Image
                              width={171}
                              height={180}
                              alt={team.title}
                              src={team.image_url}
                            />
                          </Figure>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};
HeroSection.propTypes = {
  hero_section_data: PropTypes.object,
  hero_section_list_data: PropTypes.array,
};
export { HeroSection };
